import { createSlice } from "@reduxjs/toolkit";
import http from "../../common/cticApi";

/** Converts a month-value ("01"–"12") + year string into "YYYY-MM" format.
 *  Returns an empty string when either part is absent or is the "unselected" sentinel "0". */
const formatPeriod = (month, year) => {
  if (!month || month === "0" || !year || year === "0") return "";
  return `${year}-${String(month).padStart(2, "0")}`;
};

/** Converts "Yes"/"No" radio values to boolean (null when not yet answered). */
const toBoolean = (value) => {
  if (value === "Yes") return true;
  if (value === "No") return false;
  return null;
};

// initial state
export const initialState = {
  loading: false,
  error: null,
  success: false,
  KocId: 0,
  
};

// our slice
const registrationSlice = createSlice({
  name: "registration",
  initialState,
  reducers: {
    setLoading: (state) => {
      state.loading = true;
    },
    setError: (state, { payload }) => {
      state.loading = false;
      state.error = payload;
      state.success = false;
    },
    setSuccess: (state) => {
      state.loading = false;
      state.error = false;
      state.success = true;
    },
    setKocId: (state, { payload }) => {
      state.loading = false;
      state.KocId = payload;
      state.success = true;
      state.error = false;
    },
  },
});
// export the actions
export const {
  setLoading,
  setError,
  setSuccess,
  setKocId,
} = registrationSlice.actions;

export const registrationSelector = (state) => state.registration;

// export the default reducer
export default registrationSlice.reducer;

// Registration
export const SaveKOCInfo =
  (data) => async (dispatch) => {
    try {
      dispatch(setLoading());
      var reqData = {
        Client_Type: data?.client_type,
        LanguagePreference: data.lang_type,
        Salutation: data.Salutation,
        LawFirm: data.law_firm,
        LawyerFullName:
          data.first_name +
          (data.middle_name === "" ? "" : "$" + data.middle_name) +
          "$" +
          data.last_name,
        Address1: data.address || "",
        Address2: data.unit || "",
        City: data.city,
        Province: data.Province,
        KocProvince: data.KocProvince,
        PostalCode: data.postal,
        Phone: data.phone_num,
        Ext: data.ext_num,
        Fax: data.fax_num,
        Email: data.Regemail,
        ReferredToCTICBy: data.referral || "",
        TitleInsuranceSuppliers: data?.suppliers?.join(",") || "",
        PercentageDedicated: data.Percentage,
        APPRTransactionPerMonth: data.ResiTransaction,
        APPRCommercialTranscataions: data.CommTransaction,
        PreferedPaymentMethod: data.payment_method,
        MontlyAccountStatement: data.statement,
        MontlyStatementEmail: data.accountEmail,
        AdditionComments: data.additionalInfo,
        dateFilled: data.RegDate,
        NoOfLAWYERSFIRM: data.realestate_num === "" ? 0 : data.realestate_num,
        PracticedProvince: data.currentlyPracticingProvinceArray?.join(","),
        PracticedProvinceCurrent:
          data.currentlyAuthorizedProvinceArray?.join(",") || "",
        PracticedProvincePrevious:
          data.previouslyPracticedProvinceArray?.join(",") || "",
        clerkInfo: data.clerkInfo,
        professionalHistory: (data.employmentHistory || []).map((entry) => ({
          KOCID: 0,
          EmployerName: entry.employerFirmName || "",
          PositionHeld: entry.positionHeld || "",
          PeriodFrom: formatPeriod(entry.fromMonth, entry.fromYear),
          PeriodTo: formatPeriod(entry.toMonth, entry.toYear),
        })),
        professionalHistoryQuestions: {
          KOCId: 0,
          CivilSuit: toBoolean(data.civilSuit),
          CivilSuitDetails: data.civilSuitAdditional || "",
          ChargeOrConviction: toBoolean(data.criminalOffence),
          ChargeOrConvictionDetails: data.criminalOffenceAdditional || "",
          ProposalArrangement: toBoolean(data.insolvencyProcedure),
          ProposalArrangementDetails: data.insolvencyProcedureAdditional || "",
          PetitionBankruptcy: toBoolean(data.bankruptcyProcedure),
          PetitionBankruptcyDetails: data.bankruptcyProcedureAdditional || "",
          FraudClaims: toBoolean(data.fraudClaims),
          FraudClaimsDetails: data.fraudClaimsAdditional || "",
        },
        QuestionAnswers: {
          SigningAndVerify: data.PersonalQuestion,
          SigningAndVerifyComments: data.PersonalQuestionAdditional,
          OUTSOURCEDOCUMENTPREPARATION: data.question2,
          OUTSOURCEDOCUMENTPREPARATIONcomments: data.question2Additional,
          MORTGAGELENDERDECLINED: data.mortgageQuestion,
          MORTGAGELENDERDECLINEDComments: data.mortgageQuestionAdditional,
          TITLEINSURERNotAccepted: data.title,
          TITLEINSURERNotAcceptedComments: data.titleAdditional,
          UNDERTAKENDISCIPLINARYACTIONAGAINSTYOU: data.Society,
          UNDERTAKENDISCIPLINARYACTIONAGAINSTYOUcomments:
            data.SocietyAdditional,
          AUDITOFYOURPRACTICEINTHEPAST15Y: data.practice,
          AUDITOFYOURPRACTICEINTHEPAST15YComments: data.practiceAdditional,
          TURNEDDOWNINTHEPAST15YFOREAndOLIABILITYINSURANCECOVERAGE:
            data.liability,
          TURNEDDOWNINTHEPAST15YFOREAndOLIABILITYINSURANCECOVERAGEComments:
            data.liabilityAdditional,
          Month: data.MonthName,
          Year: data.Year,
        },
      };
      // Make API call for registration
      const { data: response } =await http.post(
        "Registration/SaveKocFormBasicInfo",
        reqData
      );
      if (response.responseCode == 0) {
        dispatch(setSuccess());
        dispatch(setKocId(response.responseObject.kocID));

      } else {
        if (response.responseCode == -2) {
          dispatch(setError("-2"));
        } else {
          dispatch(setError(response.responseDescription));
        }
      }
    } catch (error) {
      const errorMessage =
        error.response && error.response.data
          ? error.response.data.title
          : error.message;
      dispatch(setError(errorMessage));
    }
  };
